import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

import {
  useSaveMetaMilestoneMutation,
  SaveMetaMilestone_Input,
  useMetaMilestoneFormQuery
} from 'generated/graphql';

export type IFormState = {
  id: string;
  included: boolean;
  notesForClient: string;
};

const initialState: IFormState = {
  id: '',
  included: true,
  notesForClient: ''
};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      },
      included: {
        label: 'Included',
        type: 'text'
      },
      notesForClient: {
        label: 'Notes',
        type: 'text'
      }
    }
  });

  const { data, loading, called } = useQuery(id);

  useEffect(() => {
    if (data.id !== '' && formState.id === '' && called && !loading) {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          ...data
        }
      });
    }
  });


  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}


export function useSaveMetaMilestone() {
  const [
    fnMutate,
    tuple
  ] = useSaveMetaMilestoneMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaMilestone_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}


export interface IData extends IFormState {}

export function useQuery(id: string) {
  const tuple = useMetaMilestoneFormQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.metaMilestone?.id ?? '',
        included: tuple.data?.metaMilestone?.included ?? true,
        notesForClient: tuple.data?.metaMilestone?.notesForClient ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
